module.exports = __webpack_public_path__ + "ddc6aff21b6e253f5dbcb7dd4e6d23c5.jpg";